import { Pipe, PipeTransform } from '@angular/core';
import { bearing, bearingToAngle, Feature, featureCollection, FeatureCollection, LineString } from '@turf/turf';
import { LineSizeProps } from './polygon-to-lines.pipe';

@Pipe({
  name: 'linesToBearingLines',
  standalone: true,
})
export class LinesToBearingLinesPipe implements PipeTransform {
  transform(
    collection: FeatureCollection<LineString, LineSizeProps>,
    apply: boolean,
  ): FeatureCollection<LineString, { distance: string }> {
    return this.setLinesBearingText(collection, apply);
  }

  private setLinesBearingText(
    data: FeatureCollection<LineString, LineSizeProps>,
    apply: boolean,
  ): FeatureCollection<LineString, { distance: string }> {
    const updatedFeatures: Feature<LineString, { distance: string }>[] = [];

    for (const it of data.features) {
      const feature = JSON.parse(JSON.stringify(it)) as Feature<LineString, LineSizeProps>;
      const showSizes = feature.properties?.showSizes !== false;
      const showDegrees = feature.properties?.showDegrees !== false;
      const baseDistance = feature.properties.distance ?? '';
      const tbearing = bearing(
        feature.geometry.coordinates[0],
        feature.geometry.coordinates[1],
      );
      const angle = bearingToAngle(tbearing);
      const angleStr = angle.toFixed(1) + '°';
      const displayAngle = apply && showDegrees;

      let label: string;
      if (displayAngle) {
        label = showSizes ? `${baseDistance} @ ${angleStr}` : angleStr;
      } else {
        label = showSizes ? baseDistance : '';
      }

      if (!label) {
        continue;
      }

      updatedFeatures.push({
        ...feature,
        properties: { distance: label },
      });
    }

    return featureCollection(updatedFeatures);
  }
}
